import angular from 'angular'

import { BarcodeService } from './barcode-service'

angular.module('webregister.services').service('barcodeService', BarcodeService)
